import { FixedAddToCart } from "../components/ProductFormControls";
import "./Product.scss";

class Page {

	/**
	 * @arg {object} opts — Options
	 * @constructor
	 */
	constructor(opts = {}) {

	}

	/** Need this to run after DOM ready? Put scripts here */
	init() {
		customElements.define("fixed-add-to-cart", FixedAddToCart);
	}
}

window.Zero = window.Zero || {};
window.Zero.page = new Page();
